// @flow
import React from 'react';
import AttachmentItem from './AttachmentItem';
import FileStorageClient from '../../models/group_chats/FileStorageClient';
import type { Attachment } from '../../models/group_chats/Attachment';
import type { Meta } from '../../models/Meta';
import Modal from '../common/Modal';
import Loader from '../common/Loader';
import ButtonFileStorage from './ButtonFileStorage';

type Props = {
  groupChatId: number,
};

type State = {
  attachments: Array<Attachment>,
  isLoadMore: boolean,
  meta: Meta,
};

export default class GroupFileStorage extends React.Component<Props, State> {
  fileStorageClient: FileStorageClient;
  listFilesNode: any;

  constructor(props: Props) {
    super(props);
    this.state = {
      meta: { current_page: 1, total_pages: 1, total_count: 1 },
      attachments: [],
      isLoadMore: false,
    };
    this.fileStorageClient = new FileStorageClient(this.props.groupChatId);
  }

  openModal = async () => {
    this.setState({ isLoadMore: true });
    const res = await this.fileStorageClient.fetchAttachments(1);
    this.setState({
      meta: res.data.meta,
      attachments: [...res.data.attachments],
      isLoadMore: false,
    });
    this.listFilesNode.scrollTop = 0;
  };

  handleScroll() {
    const {
      isLoadMore,
      meta: { next_page },
    } = this.state;
    const isAtBottom =
      this.listFilesNode.clientHeight + this.listFilesNode.scrollTop <
      this.listFilesNode.scrollHeight;
    if (isAtBottom || isLoadMore) {
      return;
    }

    if (next_page != null) {
      this.setState({
        isLoadMore: true,
      });
      this.fileStorageClient
        .fetchAttachments(next_page)
        .then(response => {
          this.setState(oldState => ({
            attachments: [
              ...oldState.attachments,
              ...response.data.attachments,
            ],
            meta: response.data.meta,
          }));
        })
        .catch(error => console.warn(error))
        .finally(() =>
          this.setState({
            isLoadMore: false,
          }),
        );
    }
  }

  render() {
    const { attachments, isLoadMore } = this.state;
    return (
      <div>
        <ButtonFileStorage onClick={() => this.openModal()} />
        <Modal
          className="modal fade modal-file-storage"
          id="file-storage-modal"
        >
          <Modal.Header>
            <strong>ファイル管理</strong>
          </Modal.Header>
          <Modal.Body>
            <div
              className="modal-file-storage__items"
              onScroll={this.handleScroll}
              ref={e => (this.listFilesNode = e)}
            >
              {attachments.map((attachment, index) => (
                <AttachmentItem item={attachment} key={index} />
              ))}
            </div>
          </Modal.Body>
        </Modal>
        {isLoadMore && <Loader />}
      </div>
    );
  }
}
